import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/action_plus.svg'
import _imports_1 from '../assets/svgs/empty.svg'
import _imports_2 from '../assets/illus-home.png'
import _imports_3 from '../assets/action_purple.svg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "flex-grow bg-background shadow-inner min-h-screen"
}
const _hoisted_4 = { class: "container p-3 lg:py-8" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "space-y-3 sm:flex flex-row justify-end items-center" }
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_9 = { class: "flex flex-col lg:flex-row justify-between w-full lg:pt-8 lg:space-x-6 mt-4 lg:mt-0" }
const _hoisted_10 = { class: "flex flex-col bg-white p-4 lg:card-main md:card-main w-full lg:w-1/2 mt-3 lg:mt-0 rounded-lg shadow-lg" }
const _hoisted_11 = { class: "flex flex-row justify-between items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Notifications", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "flex flex-col justify-center items-center w-full h-full"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "160"
  })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "p-5" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "space-y-3 pt-8 w-auto rounded",
  style: {"background-color":"#eff0f6"}
}
const _hoisted_19 = { class: "container grid justify-items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-16 w-24"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl pt-5 text-black" }, "You have not created any jobs yet.", -1)
const _hoisted_22 = { class: "pt-10 pb-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CardsCount = _resolveComponent("CardsCount")!
  const _component_LastCandidates = _resolveComponent("LastCandidates")!
  const _component_NotificationList = _resolveComponent("NotificationList")!
  const _component_SkeletonNotifications = _resolveComponent("SkeletonNotifications")!
  const _component_CardSuggestions = _resolveComponent("CardSuggestions")!
  const _component_ModalUpgradePlan = _resolveComponent("ModalUpgradePlan")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Loading, {
              active: _ctx.isLoading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
              "can-cancel": true,
              loader: "spinner",
              color: "#8908F9",
              width: 128,
              height: 128,
              opacity: 0.5,
              "is-full-page": true
            }, null, 8, ["active", "opacity"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Button, {
                      variant: "contained",
                      label: "Create new job",
                      onOnClick: _ctx.createNewJob
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onOnClick"])
                  ])
                ]),
                (_ctx.analytics && Object.keys(_ctx.analytics)?.length !== 0)
                  ? (_openBlock(), _createBlock(_component_CardsCount, {
                      key: 0,
                      analytics: _ctx.analytics
                    }, null, 8, ["analytics"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.analytics?.recent_candidates)
                    ? (_openBlock(), _createBlock(_component_LastCandidates, {
                        key: 0,
                        candidates: _ctx.analytics?.recent_candidates
                      }, null, 8, ["candidates"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Button, {
                        variant: "",
                        label: "See all",
                        onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/notifications')))
                      })
                    ]),
                    (_ctx.notifications.length > 0)
                      ? (_openBlock(), _createBlock(_component_NotificationList, {
                          key: 0,
                          notifications: _ctx.notifications,
                          dashboard: true
                        }, null, 8, ["notifications"]))
                      : _createCommentVNode("", true),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2], (item, index) => {
                            return _createElementVNode("div", { key: index }, [
                              _createVNode(_component_SkeletonNotifications)
                            ])
                          }), 64))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.notifications.length <= 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_CardSuggestions),
                _hoisted_17,
                (_ctx.analytics?.total_jobs <= 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_Button, {
                            variant: "outlined",
                            label: "Create new job",
                            onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/create-job')))
                          }, {
                            endIcon: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = false)),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalUpgradePlan, {
          onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = false)),
          infoType: "jobs"
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}